import { z } from "zod";

export const flooringTypes = [
  "Carpet",
  "LVT",
  "Laminate",
  "Vinyl",
  "Herringbone",
  "Artificial grass",
  "Not sure yet",
] as const;

export const quoteSchema = z.object({
  name: z.string().trim().min(2, "Please enter your name").max(80),
  phone: z.string().trim().min(10, "Please enter a UK phone number").max(24),
  email: z.string().trim().email("Please enter a valid email").or(z.literal("")),
  postcode: z
    .string()
    .trim()
    .regex(/^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/, "Please enter a valid UK postcode"),
  flooringType: z.enum(flooringTypes),
  rooms: z.string().trim().max(800),
  preferredContact: z.enum(["Phone", "WhatsApp", "Email"]),
  preferredDate: z.string().trim().max(20),
  consent: z.boolean().refine((value) => value, "Please agree so we can contact you"),
  website: z.string().max(0).optional(),
});

export const contactSchema = z.object({
  name: z.string().trim().min(2).max(80),
  email: z.string().trim().email(),
  phone: z.string().trim().max(24),
  message: z.string().trim().min(10).max(1500),
  consent: z.boolean().refine((value) => value, "Please agree so we can reply"),
  website: z.string().max(0).optional(),
});

export const trackSchema = z.object({
  reference: z.string().trim().toUpperCase().regex(/^HF-[A-Z0-9]{6,12}$/),
  postcode: z.string().trim().min(5).max(10),
});

export type QuoteInput = z.infer<typeof quoteSchema>;
export type ContactInput = z.infer<typeof contactSchema>;
export type TrackInput = z.infer<typeof trackSchema>;
